import { Add as AddIcon } from '@mui/icons-material';
import { IconButton, Tooltip, Button } from '@mui/material';
import { permission } from '@nohara-dxdev/oidc-core';
import { OidcProtectedComponent, useScopeIds } from '@nohara-dxdev/react-oidc';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobalCreateTaskDialog } from './global-create-task-dialog';

const createTaskPermissions = [permission.task.create];

export interface GlobalCreateTaskButtonProps {
  showName?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
}

export const GlobalCreateTaskButton = ({
  showName = false,
  variant = 'contained',
  size = 'small',
}: GlobalCreateTaskButtonProps) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const scopeIds = useScopeIds();

  const subject = useMemo(
    () => ({
      ...scopeIds,
    }),
    [scopeIds],
  );

  return (
    <OidcProtectedComponent requireAll={createTaskPermissions} subject={subject}>
      {showName ? (
        <Button
          color="primary"
          onClick={() => {
            setDialogOpen(true);
          }}
          size={size}
          variant={variant}
          startIcon={<AddIcon />}
        >
          {t('tasks.create.button')}
        </Button>
      ) : (
        <Tooltip title={t('tasks.create.button')}>
          <IconButton
            color="primary"
            onClick={() => {
              setDialogOpen(true);
            }}
            size={size}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      )}

      <GlobalCreateTaskDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
      />
    </OidcProtectedComponent>
  );
};
